/* eslint-disable no-tabs */
import { COMPANY_PROFILE_DEFAULT } from 'components/icons/constants';
import PropTypes from 'prop-types';

const BranchesIcon = ({
    color = COMPANY_PROFILE_DEFAULT.color,
    size = COMPANY_PROFILE_DEFAULT.size
}) => (
    <svg
        version="1.1"
        id="Layer_1"
        x="0px"
        y="0px"
        width={size}
        height={size}
        viewBox="0 0 70.865 70.867"
        enableBackground="new 0 0 70.865 70.867"
    >
        <g>
            <path
                fill={color}
                d="M12.24,58.628c3.012,3.013,6.52,5.377,10.425,7.028c4.044,1.712,8.34,2.578,12.769,2.578
		c4.426,0,8.723-0.866,12.767-2.578c3.906-1.651,7.414-4.016,10.427-7.028c3.012-3.013,5.375-6.52,7.028-10.425
		c1.711-4.043,2.579-8.341,2.579-12.768c0-4.429-0.867-8.724-2.579-12.768c-1.652-3.906-4.016-7.413-7.028-10.425
		c-3.013-3.014-6.521-5.378-10.427-7.03c-4.044-1.712-8.34-2.579-12.767-2.579c-4.429,0-8.725,0.867-12.769,2.579
		c-3.906,1.652-7.414,4.017-10.425,7.03c-3.012,3.012-5.377,6.519-7.03,10.425c-1.71,4.044-2.578,8.339-2.578,12.768
		c0,4.427,0.868,8.725,2.578,12.768C6.863,52.108,9.228,55.615,12.24,58.628z M35.434,4.578c17.013,0,30.856,13.843,30.856,30.857
		c0,17.014-13.843,30.856-30.856,30.856c-17.015,0-30.857-13.843-30.857-30.856C4.577,18.421,18.419,4.578,35.434,4.578z"
            />
            <path
                fill={color}
                d="M22.766,32.679c0.284,1.685,0.831,3.211,1.629,4.538c0.407,0.676,0.85,1.326,1.279,1.958
		c0.329,0.481,0.669,0.981,0.981,1.476c1.939,3.077,3.899,6.213,5.794,9.246l1.276,2.042c0.423,0.676,1.049,1.063,1.718,1.063
		c0.668,0,1.289-0.387,1.701-1.063c0.067-0.11,0.135-0.223,0.203-0.333c0.147-0.244,0.287-0.473,0.432-0.704
		c0.615-0.969,1.229-1.938,1.845-2.907c2.075-3.274,4.22-6.662,6.347-9.981c0.532-0.829,1.13-1.834,1.539-2.982
		c0.787-2.22,0.977-4.545,0.564-6.915c-0.514-2.951-2.049-5.664-4.324-7.642c-2.311-2.008-5.232-3.113-8.228-3.113h-0.07h-0.081
		c-1.301,0-2.551,0.191-3.715,0.572c-2.996,0.978-5.544,3.008-7.176,5.716C22.849,26.357,22.239,29.564,22.766,32.679z
		M32.259,19.779c0.969-0.315,2.016-0.476,3.112-0.476h0.074c0.004,0,0.009,0,0.013,0h0.063c5.156,0,9.729,3.933,10.638,9.146
		c0.354,2.035,0.193,4.03-0.482,5.93c-0.34,0.963-0.87,1.847-1.343,2.586c-2.128,3.324-4.275,6.711-6.353,9.987
		c-0.614,0.97-1.228,1.938-1.843,2.908c-0.157,0.247-0.308,0.497-0.453,0.739c-0.067,0.108-0.131,0.217-0.198,0.324
		c-0.018,0.03-0.034,0.053-0.049,0.071c-0.019-0.022-0.041-0.052-0.063-0.089l-1.276-2.041c-1.896-3.034-3.857-6.174-5.799-9.252
		c-0.33-0.524-0.68-1.039-1.018-1.536c-0.433-0.635-0.842-1.233-1.219-1.862c-0.672-1.116-1.136-2.417-1.379-3.859
		C23.76,26.896,27.019,21.49,32.259,19.779z"
            />
            <path
                fill={color}
                d="M47.234,22.728c0.353-0.042,0.719-0.063,1.091-0.06c0.004,0,0.008,0,0.012,0c0.017,0,0.035,0,0.052,0
		c4.186,0,7.892,3.183,8.632,7.424c0.288,1.653,0.156,3.276-0.392,4.819c-0.277,0.78-0.709,1.502-1.094,2.105
		c-1.763,2.749-3.54,5.556-5.259,8.269c-0.506,0.797-1.014,1.596-1.521,2.395c-0.13,0.207-0.255,0.414-0.375,0.614
		c-0.022,0.035-0.043,0.069-0.063,0.104l-0.918-1.471c-0.734-1.173-1.469-2.349-2.203-3.52c-0.284-0.455-0.884-0.592-1.339-0.31
		c-0.455,0.286-0.593,0.885-0.308,1.339c0.734,1.174,1.467,2.348,2.201,3.521l1.011,1.619c0.381,0.608,0.95,0.958,1.562,0.958
		c0.003,0,0.005,0,0.008,0c0.61-0.003,1.173-0.354,1.543-0.96c0.056-0.093,0.113-0.186,0.168-0.277
		c0.122-0.201,0.236-0.391,0.354-0.578c0.508-0.798,1.015-1.598,1.521-2.397c1.718-2.71,3.495-5.513,5.253-8.26
		c0.447-0.694,0.948-1.535,1.291-2.503c0.66-1.861,0.819-3.815,0.475-5.803c-0.435-2.488-1.732-4.773-3.654-6.436
		c-1.954-1.689-4.424-2.612-6.95-2.598c-0.451-0.003-0.896,0.021-1.327,0.072c-0.533,0.063-0.914,0.549-0.85,1.081
		C46.218,22.411,46.703,22.793,47.234,22.728z"
            />
            <path
                fill={color}
                d="M18.956,46.336c0.504,0.796,1.009,1.592,1.512,2.385c0.119,0.188,0.232,0.377,0.354,0.578
		c0.056,0.092,0.111,0.185,0.168,0.279c0.372,0.604,0.934,0.955,1.542,0.958c0.003,0,0.006,0,0.009,0
		c0.612,0,1.181-0.35,1.563-0.958l1.012-1.619c0.732-1.174,1.466-2.348,2.201-3.521c0.285-0.454,0.146-1.053-0.308-1.339
		c-0.456-0.282-1.055-0.146-1.339,0.31c-0.734,1.171-1.468,2.347-2.203,3.52l-0.917,1.471c-0.022-0.035-0.044-0.069-0.063-0.104
		c-0.122-0.2-0.248-0.407-0.377-0.614c-0.504-0.793-1.009-1.59-1.512-2.385c-1.722-2.716-3.501-5.523-5.267-8.28
		c-0.386-0.602-0.816-1.322-1.093-2.104c-0.549-1.543-0.681-3.166-0.392-4.819c0.738-4.241,4.445-7.424,8.632-7.424
		c0.017,0,0.034,0,0.051,0c0.004,0,0.008,0,0.013,0c0.37-0.002,0.738,0.018,1.09,0.06c0.534,0.065,1.017-0.316,1.081-0.85
		c0.063-0.532-0.317-1.018-0.851-1.081c-0.432-0.051-0.876-0.075-1.327-0.072c-2.529-0.019-4.997,0.908-6.95,2.598
		c-1.923,1.662-3.22,3.947-3.653,6.436c-0.347,1.987-0.188,3.941,0.473,5.803c0.343,0.968,0.845,1.809,1.289,2.503
		C15.456,40.814,17.235,43.621,18.956,46.336z"
            />
        </g>
    </svg>
);

BranchesIcon.propTypes = {
    color: PropTypes.string.isRequired,
    size: PropTypes.number
};

export default BranchesIcon;
